import { ThemeOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    title1: React.CSSProperties;
    title2: React.CSSProperties;
    breadcrumbActive: React.CSSProperties;
    breadcrumbInactive: React.CSSProperties;
    cardTitle1: React.CSSProperties;
    cardSubTitle1: React.CSSProperties;
    inputLabel1: React.CSSProperties;
    modalTitle1: React.CSSProperties;
    modalSubtitle1: React.CSSProperties;
    modalOptions: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    title1?: React.CSSProperties;
    title2?: React.CSSProperties;
    breadcrumbActive?: React.CSSProperties;
    breadcrumbInactive?: React.CSSProperties;
    cardTitle1?: React.CSSProperties;
    cardSubTitle1: React.CSSProperties;
    inputLabel1?: React.CSSProperties;
    modalTitle1: React.CSSProperties;
    modalSubtitle1: React.CSSProperties;
    modalOptions: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    title1: true;
    title2: true;
    breadcrumbActive: true;
    breadcrumbInactive: true;
    cardTitle1: true;
    cardSubTitle1: true;
    inputLabel1: true;
    modalTitle1: true;
    modalSubtitle1: true;
    modalOptions: true;
  }
}

export const typography: ThemeOptions['typography'] = {
  fontFamily: 'Manrope, sans-serif',

  h3: {
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '32px',
  },

  body1: {
    color: '#141417',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    fontFamily: 'Manrope, sans-serif',
  },

  body2: {
    color: '#141417',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    fontFamily: 'Manrope, sans-serif',
  },

  subtitle1: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16px',
  },

  caption: {
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '14px',
  },

  title1: {
    color: '#141417',
    fontWeight: 600,
    fontSize: '32px',
    lineHeight: '40px',
    fontFamily: 'Manrope, sans-serif',
  },

  title2: {
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '32px',
    fontFamily: 'Manrope, sans-serif',
  },

  breadcrumbActive: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#141417',
    fontFamily: 'Manrope, sans-serif',
  },

  breadcrumbInactive: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#A1A1A1',
    fontFamily: 'Manrope, sans-serif',
  },

  cardTitle1: {
    color: '#141417',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '32px',
    fontFamily: 'Manrope, sans-serif',
  },

  cardSubTitle1: {
    color: '#6F6F6F',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16px',
    fontFamily: 'Manrope, sans-serif',
  },

  inputLabel1: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '16px',
    fontFamily: 'Manrope, sans-serif',
    height: '16px',
  },

  modalTitle1: {
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '28px',
  },

  modalSubtitle1: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
  },

  modalOptions: {
    color: '#141417',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '16px',
    fontFamily: 'Manrope, sans-serif',
  },
};
